import React, {useEffect} from 'react'
import '../../App.css'
import Gallery from '../Gallery'
import { useTranslation } from 'react-i18next'
import {motion} from "framer-motion"
import p1 from '../../images/interior_actual/living6.jpg';
import p2 from '../../images/interior_actual/living7.jpg'
import p3 from '../../images/interior_actual/living8.jpg'
import p4 from '../../images/interior_actual/kitchen4.jpg'
import p5 from '../../images/interior_actual/powder1.jpg'
import p6 from '../../images/interior_actual/bedroom4.jpg'
import p7 from '../../images/interior_actual/bathroom3.jpg'
import p8 from '../../images/interior_actual/bedroom1.jpg'
import p9 from '../../images/interior_actual/bathroom2.jpg'

export default function Interior () {
   const { t } = useTranslation();

   useEffect(() => {
      window.scrollTo(0, 0);
   }, []);

   return (
      <motion.div
         exit={{opacity:0}}
         animate={{opacity:1}}
         initial={{opacity:0}}
         transition={{duration:1}}>
         <div className='gallery-text-wrapper'>
            <div className="gallery-header">
               <h2>
                  {t("interior-title")}
               </h2>
            </div>
            <p>
            {t("interior-text")}
            </p>
         </div>

         <Gallery
                  src1={p1}
                  src2={p2}
                  src3={p3}
                  src4={p4}
                  src5={p5}
                  src6={p6}
                  src7={p7}
                  src8={p8}
                  src9={p9}/>
      </motion.div>
   )
}